module.exports = __webpack_public_path__ + "fonts/Source_Serif_4-normal-900-latin.77d8552.woff2";